import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router";
import Layout from "../../Layout";
import MenuManagementPage from "../MenuManagementPage";
import menu from "./menu";
import {
  withPermission,
  PermissionContext,
  Roles,
} from "../../../util/PermissionProvider";
import BannerListingPage from "../BannerListingPage";
import BannerDetailPage from "../BannerDetailPage";
import AboutUsPage from "../AboutUsPage";
import ContactUsPage from "../ContactUsPage";

import AppVersionPage from "../AppVersionPage";

export default function HKIFFAppSection(props) {
  const { match } = props;
  const { userPermissions } = useContext(PermissionContext);
  console.log(match.url);
  return (
    userPermissions && (
      <Layout menuObj={menu}>
        <Switch>
          <Route
            exact
            path={`${match.url}/app-version`}
            component={withPermission(
              AppVersionPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/about-us`}
            component={withPermission(
              AboutUsPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/contact-us`}
            component={withPermission(
              ContactUsPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/banner`}
            component={withPermission(
              BannerListingPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/banner/:id`}
            component={withPermission(
              BannerDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            exact
            path={`${match.url}/banner/create/:type`}
            component={withPermission(
              BannerDetailPage,
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
              [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
            )}
          />
          <Route
            // exact
            path={`${match.url}/menu`}
            component={MenuManagementPage}
          />
          <Route
            render={() => <Redirect to={`${match.url}/app-version`} />}
          />
        </Switch>
      </Layout>
    )
  );
}
